export default {
  signature: {
    qa: 'Qualitätskontrolle',
    lab: 'Labor',
  },
  errors: {
    downloadPdfFailed: 'Der Download des Qualitätsberichts ist fehlgeschlagen: {report}. Sollte dieser Fehler vermehrt auftreten bitte wenden Sie sich an den Qmulus support.',
  },
};
